import React, { useState } from "react";
import deemedLogo from "../../../resources/assets/logo.png";
import "./Login.css";

import res from "../../../resources";
import LoginForm from "components/common/LoginForm/LoginForm";

export default function Login() {
  return (
    <div className="loginBgDoc2">
      <div className="wrapper-center2">
        <div className="row log_wrapper2">
          <div className="text-white log_left2 ">
            {/* <img
              className="logo-img2"
              src={res.Images.logo.deedmed.default}
              alt="logo"
            /> */}
            <img className="logo-img2" src={deemedLogo} alt="logo" />
            <h4 className="log_saying2">
              doctor is not a mechanic.
              <br />
              A car doesn't react with a<br />
              mechanic, but a human <br /> being does.
            </h4>
            <h4 className="log_saying_name2">- Randa Haines</h4>
          </div>
          <LoginForm />
        </div>
      </div>
    </div>
  );
}
export { Login };
